import { URLS } from "@/lib/consts";
import type { Industry } from "../types";

export const INDUSTRIES: Industry[] = [
  {
    key: "construction",
    label: "Construction",
    description:
      "Specialized construction accounting services, tax services, and management consulting services specific to the needs of construction companies.",
    href: URLS.INDUSTRIES.CONSTRUCTION,
    imageUrl: "construction",
    imageAlt:
      "Construction industry in Houston, Texas - workers, cranes, and active building projects",
    relatedKeys: [
      "audit-of-financial-statements",
      "budgeting-and-forecasts",
      "cash-flow-management",
      "tax-planning",
      "tax-compliance",
    ],
  },
  {
    key: "manufacturing",
    label: "Manufacturing",
    description:
      "Depreciation, franchise valuation, transaction structuring, succession planning. Additional sector specialties for automotive dealerships, cannabis and food and beverage businesses.",
    href: URLS.INDUSTRIES.MANUFACTURING,
    imageUrl: "manufacturing",
    imageAlt:
      "Manufacturing industry in Houston, Texas - factory operations and industrial machinery",
    relatedKeys: [
      "audit-of-financial-statements",
      "gaap-implementation",
      "tax-compliance",
      "tax-planning",
    ],
  },
  {
    key: "real-estate",
    label: "Real Estate",
    description:
      "CPA services tailored for real estate investors, developers, and property managers, including 1031 exchanges, cost segregation, and entity structuring.",
    href: URLS.INDUSTRIES.REAL_ESTATE,
    imageUrl: "real-estate",
    imageAlt:
      "Real Estate industry in Houston, Texas - commercial buildings and residential housing",
    relatedKeys: [
      "cash-flow-management",
      "succession-planning-and-wealth-transfer",
      "tax-planning",
      "tax-compliance",
      "estate-and-trusts",
    ],
  },
  {
    key: "technology",
    label: "Technology",
    description:
      "Scalable accounting and tax strategies for startups, SaaS companies, and IT firms - including R&D tax credits, equity compensation, and growth planning.",
    href: URLS.INDUSTRIES.TECHNOLOGY,
    imageUrl: "technology",
    imageAlt:
      "Technology industry in Houston, Texas - modern office with software engineers collaborating",
    relatedKeys: [
      "budgeting-and-forecasts",
      "part-time-controller-cfo",
      "tax-planning",
      "tax-compliance",
      "software-selection-and-implementation",
    ],
  },
  {
    key: "transportation",
    label: "Transportation",
    description:
      "Accounting and advisory services for logistics, freight, and trucking companies - fuel tax reporting, asset depreciation, and DOT compliance support.",
    href: URLS.INDUSTRIES.TRANSPORTATION,
    imageUrl: "transportation",
    imageAlt:
      "Transportation industry in Houston, Texas - freight trucks, logistics, and shipping hubs",
    relatedKeys: [
      "audit-of-financial-statements",
      "cash-flow-management",
      "budgeting-and-forecasts",
      "tax-planning",
      "tax-compliance",
    ],
  },
  {
    key: "oil-and-gas",
    label: "Oil & Gas",
    description:
      "Tax planning, joint venture accounting, and mineral rights advisory tailored to upstream and midstream oil and gas businesses across Texas.",
    href: URLS.INDUSTRIES.OIL_AND_GAS,
    imageUrl: "oil-and-gas",
    imageAlt:
      "Oil & Gas industry in Houston, Texas - refineries and energy production facilities",
    relatedKeys: [
      "audit-of-financial-statements",
      "succession-planning-and-wealth-transfer",
      "tax-planning",
      "tax-compliance",
      "gaap-implementation",
    ],
  },
  {
    key: "healthcare",
    label: "Healthcare",
    description:
      "Healthcare-focused CPA services for physicians, dentists, clinics, and private practices - covering payroll, tax planning, and regulatory compliance.",
    href: URLS.INDUSTRIES.HEALTHCARE,
    imageUrl: "healthcare",
    imageAlt:
      "Healthcare industry in Houston, Texas - doctors, nurses, and modern medical facilities",
    relatedKeys: [
      "medicare-cost-reports",
      "audit-of-financial-statements",
      "cash-flow-management",
      "tax-planning",
      "tax-compliance",
    ],
  },
  {
    key: "ranching-and-agribusiness",
    label: "Ranching & Agribusiness",
    description:
      "Dedicated CPA support for farms, ranches, and agricultural enterprises - from livestock accounting and commodity taxation to estate planning.",
    href: URLS.INDUSTRIES.RANCHING_AND_AGRIBUSINESS,
    imageUrl: "ranching-and-agribusiness",
    imageAlt:
      "Ranching and Agribusiness industry in Texas - cattle ranches, farming, and agricultural operations",
    relatedKeys: [
      "succession-planning-and-wealth-transfer",
      "estate-and-trusts",
      "tax-planning",
      "tax-compliance",
      "cash-flow-management",
    ],
  },
  {
    key: "professional",
    label: "Professional",
    description:
      "Comprehensive accounting services for law firms, consultants, architects, and other professionals - including tax optimization and cash flow management.",
    href: URLS.INDUSTRIES.PROFESSIONAL,
    imageUrl: "professional",
    imageAlt:
      "Professional services industry in Houston, Texas - corporate meetings and office teamwork",
    relatedKeys: [
      "part-time-controller-cfo",
      "cash-flow-management",
      "budgeting-and-forecasts",
      "tax-planning",
      "tax-compliance",
    ],
  },
  {
    key: "nonprofits",
    label: "Nonprofits",
    description:
      "Nonprofit accounting services for charitable organizations, foundations, and churches - including 990 filings, grant compliance, and donor reporting.",
    href: URLS.INDUSTRIES.NONPROFITS,
    imageUrl: "nonprofits",
    imageAlt:
      "Nonprofit industry in Houston, Texas - volunteers and community service organizations",
    relatedKeys: [
      "audit-of-financial-statements",
      "cash-flow-management",
      "budgeting-and-forecasts",
      "tax-planning",
      "tax-compliance",
    ],
  },
];

export const INDUSTRIES_BY_KEY = Object.fromEntries(
  INDUSTRIES.map(industry => [industry.key, industry]),
);
